import { getAptListAPI } from "@/apis/admin-api"
import { create } from "zustand"
import { createListStore } from "../create-list-store-util"

export const adminAptStore = create(createListStore(getAptListAPI))
